import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { title, t } from '~/helpers';
import AuthLayout from '~/pages/_layouts/auth';
import DefaultLayout from '~/pages/_layouts/default';
import FotoNFLayout from '~/pages/_layouts/fotonf';
import FullScreenLayout from '~/pages/_layouts/fullscreen';
import ReleaseLayout from '~/pages/_layouts/release';
import { store } from '~/store';

export default function RouteWrapper({
  component: Component,
  fullScreen,
  isPrivate,
  title: Title,
  ...rest
}) {
  const { signed } = store.getState().auth;

  const translate = useSelector((state) => state.language);

  const releaseLayout = rest.path === '/changesrelease';

  const fotoNFLayout = rest.path === '/fotonf' || rest.path === '/fotonflocal';

  useEffect(() => {
    if (!isEmpty(Title)) {
      title(t(Title));
    } else {
      title('');
    }
  }, [translate, Title]);

  if (!signed && isPrivate) {
    if (rest.path === '/fotonflocal') {
      return <Redirect to="/fotonflocal" />;
    }

    if (rest.path === '/fotonf') {
      return <Redirect to="/fotonf" />;
    }
    if (rest.path === '/changesrelease') {
      return <Redirect to="/changesrelease" />;
    }
    return <Redirect to="/" />;
  }

  // if (signed && !isPrivate && rest.path !== '/changesrelease') {
  if (
    signed &&
    !isPrivate &&
    rest.path !== '/changesrelease' &&
    rest.path !== '/fotonf' &&
    rest.path !== '/fotonflocal'
  ) {
    // if (signed && !isPrivate && rest.path !== '/changesrelease' && rest.path !== '/fotonf') {
    // return <Redirect to="/dashboard" />;
    return <Redirect to="/blank" />;
  }

  let Layout = '';

  if (signed) {
    if (fullScreen) {
      Layout = FullScreenLayout;
    } else if (releaseLayout || fotoNFLayout) {
      Layout = releaseLayout ? ReleaseLayout : FotoNFLayout;
    } else {
      Layout = DefaultLayout;
    }
  } else if (releaseLayout || fotoNFLayout) {
    Layout = releaseLayout ? ReleaseLayout : FotoNFLayout;
  } else {
    Layout = AuthLayout;
  }

  // const Layout = signed ? releaseLayout ? ReleaseLayout : DefaultLayout : releaseLayout ? ReleaseLayout : AuthLayout;
  // const Layout = signed
  //   ? releaseLayout
  //     ? ReleaseLayout
  //     : DefaultLayout
  //   : releaseLayout
  //   ? ReleaseLayout
  //   : AuthLayout;

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
  /* return (
    <Route
      {...rest}
      render={(props) => (
        fullScreen ? (
          <Component {...props} />
        ) : (
          <Layout>
            <Component {...props} />
          </Layout>
        )
      )}
    />
  ); */
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  fullScreen: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  title: PropTypes.string,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
  title: '',
  fullScreen: false,
};
